import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { QuoteEnvironment } from "./quote-return-label";

/** Countries a return-label quote can take with no address, and the address each stands for. */
export const listQuoteSampleAddresses = unaryRpc({
  name: "listQuoteSampleAddresses" as const,
  input: z.object({}),
  output: z.object({
    addresses: z.array(
      z.object({
        country: z.string(),
        street1: z.string(),
        city: z.string(),
        state: z.string().optional(),
        zip: z.string().optional(),
      }),
    ),
    environment: z.nativeEnum(QuoteEnvironment),
  }),
});
